import { animate, query, stagger, state, style, transition, trigger } from '@angular/animations'

export const slideInOutAnimation = trigger('slideInOutAnimation', [
  state(
    'enter',
    style({
      left: '-100%',
      opacity: 0,
    }),
  ),
  state(
    'stable',
    style({
      left: '0%',
      opacity: 1,
    }),
  ),
  state(
    'leave',
    style({
      left: '-100%',
      opacity: 0,
    }),
  ),
  transition('enter => stable', [animate('0.5s ease-in-out')]),
  transition('stable => leave', [animate('0.5s ease-in-out')]),
  transition('leave => enter', [animate('0.5s ease-in-out')]),
])

export const fadeInOut = trigger('fadeInOut', [
  state('in', style({ opacity: 1 })),
  transition(':enter', [style({ opacity: 0 }), animate(100)]),
  transition(':leave', animate(100, style({ opacity: 0 }))),
])

export const listAnimation = trigger('listAnimation', [
  transition('* <=> *', [
    query(':enter', [
      style({ opacity: 0, transform: 'translateY(-15px)' }),
      stagger('50ms', animate('200ms ease-out', style({ opacity: 1, transform: 'translateY(0px)' })))
    ], { optional: true })
  ])
])

export const reverseListAnimation = trigger('reverseListAnimation', [
  transition('* <=> *', [
    query(
      ':enter',
      [
        style({ opacity: 0, transform: 'translateY(15px)' }),
        stagger('-150ms', animate('200ms ease-out', style({ opacity: 1, transform: 'translateY(0px)' }))),
      ],
      { optional: true },
    ),
  ]),
])

export const listAnimationFadeIn = trigger('listAnimationFadeIn', [
  transition('* <=> *', [
    query(
      ':enter',
      [
        style({ opacity: 0, transform: 'translateY(-15px)' }),
        stagger('50ms', animate('200ms ease-out', style({ opacity: 1, transform: 'translateY(0px)' }))),
      ],
      { optional: true },
    ),
  ]),
])
